import React from "react";
import { Link } from "react-router-dom";

import Circlepink from "../images/Circlepink.svg";
import CircleOrange from "../images/CircleOrange.svg";
import CirclePurple from "../images/Circlepurple.svg";
import Circledark from "../images/Circledark.svg";

const Navbar = () => {
  return (
    <div className="w-full h-full text-white ">
      <header className="headerbg  h-2/5">
        <div className="w-full bg-center bg-cover">
          
          

      <div className=" justify-center flex relative">

        <img
          src={Circledark}
          alt="Svg"
          className="absolute pulsate-fwd4small sm:pulsate-fwd4 z-0"
        />

        <img
          src={CirclePurple}
          alt="Svg"
          className="absolute pulsate-fwd3small sm:pulsate-fwd3  z-0"
        />

        <img
          src={CircleOrange}
          alt="Svg"
          className="absolute pulsate-fwd2small sm:pulsate-fwd2  z-0"
        />

        <img
          src={Circlepink}
          alt="Svg"
          className="absolute pulsate-fwdsmall SM:pulsate-fwd  z-0"
        />
              <img
          src="/srslogo.png"
          width="500"
          height="100"
          alt="Salt River Shakedown"

          className=" z-10"
        />

    
      </div>
      <nav className="flex justify-center gap-3 sm:gap-6 text-xl sm:text-2xl relative font-semibold ">
        <Link
          className="hover:scale-110 ease-in-out duration-100 text-srs-white "
          to="/" 
        >
          Home
        </Link>

        <Link
          className="hover:scale-110 ease-in-out duration-100 font-semibold text-srs-white "
          to="/Music" 
        >
          Music
        </Link>
        <Link
          className="hover:scale-110 ease-in-out duration-100 font-bold text-srs-white"
          to="/about" 
        >
          About
        </Link>
        <Link
          className="hover:scale-110 ease-in-out duration-100 font-semibold text-srs-white "
          to="/Gigs" 
        >
          Gigs
        </Link>
        <Link
          className="hover:scale-110 ease-in-out duration-100 font-semibold text-srs-white "
          to="https://srs.yupstuff.net/" target="_blank"
        >
          Shop
        </Link>
      </nav>
          <div className="flex items-center justify-center w-full h-full  py-44">
            <div className="text-center">
              <div className="container px-4 mx-auto"></div>
            </div>
          </div>
        </div>
      </header>
    </div>
  );
};

export default Navbar;
